import axios from 'axios'
import { ROOT_URL } from './factory/Siprec'
import qs from 'qs'

const clientId = process.env.CLIENT_ID
const clientSecret = process.env.CLIENT_SECRET

export default {
  getToken (username, password) {
    return axios.request({
      url: `${ROOT_URL}/oauth/token`,
      method: 'post',
      auth: {
        username: clientId,
        password: clientSecret
      },
      data: qs.stringify({
        grant_type: 'password',
        username,
        password
      }),
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      }
    })
    .then(response => response.data)
  },

  refreshToken (token) {
    return axios
      .request({
        method: 'post',
        url: `${ROOT_URL}/oauth/token`,
        data: qs.stringify({
          grant_type: 'refresh_token',
          refresh_token: token
        }),
        auth: {
          username: clientId,
          password: clientSecret
        }
      })
      .then(response => response.data)
  }
}



// WEBPACK FOOTER //
// ./src/models/OAuth.js